import React, { useState } from 'react';
import { useLocation, useNavigate, Link, Outlet } from 'react-router-dom';
import { Menu, X, Plus, FileText, SquarePen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { groupChats } from '../utils';
import '../styles/MobileLayout.css';
import ChatInterface from './ChatInterface';

const MobileLayout = ({ userCases, selectedCase, setSelectedCase, handleNewCase, handleNewChat, caseChats, refreshCaseChats, onCaseNameUpdate }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="mobile-layout">
      <header className="mobile-header">
        <button onClick={toggleSidebar} className="menu-button">
          {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <div className="header-center">
          <img src="logo_dark.png" alt="Paribus Logo" className="mobile-logo" />
          <h1 className="header-title">
            <span>P</span>
            <span>a</span>
            <span>r</span>
            <span>i</span>
            <span>b</span>
            <span>u</span>
            <span>s</span>
          </h1>
        </div>
        <button onClick={() => handleNewChat(selectedCase)} className="new-chat-button">
          <SquarePen size={24} />
        </button>
      </header>

      <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="case-selector">
          <select 
            value={selectedCase}
            onChange={(e) => {
              const newCaseId = e.target.value;
              setSelectedCase(newCaseId);
              if (newCaseId) handleNewChat(newCaseId);
              setIsSidebarOpen(false);
            }}
          >
            <option value="">Select case...</option>
            {userCases.map((c) => (
              <option key={c.case_id} value={c.case_id}>{c.case_name}</option>
            ))}
          </select>
        </div>
        <div className="case-actions">
          <button onClick={() => { handleNewCase(); setIsSidebarOpen(false); }} className="action-btn new-case-btn">
            <Plus size={16} /> New Case
          </button>
          {selectedCase && (
            <Link to={`/files?caseId=${selectedCase}`} className="action-btn manage-files-btn" onClick={() => setIsSidebarOpen(false)}>
              <FileText size={16} /> Manage Files
            </Link>
          )}
        </div>
        
        <div className="chat-history">
          {Object.entries(groupChats(caseChats)).map(([groupName, chats]) => (
            chats.length > 0 && (
              <div key={groupName} className="chat-group">
                <h3 className="group-header">{groupName}</h3>
                <ul>
                  {chats.map((chat) => (
                    <li key={chat.chat_id}>
                      <button onClick={() => {
                        navigate(`/chat?chatId=${chat.chat_id}`);
                        setIsSidebarOpen(false);
                      }}>
                        <span>{chat.summary}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )
          ))}
        </div>

        <div className="user-info">
          <span>{user.email}</span>
          <button onClick={() => { signOut(); setIsSidebarOpen(false); }} className="logout-btn">
            Logout
          </button>
        </div>
      </div>

      <main className="mobile-content">
        {location.pathname.startsWith('/chat') ? (
          <ChatInterface onSummaryUpdate={refreshCaseChats} />
        ) : (
          <Outlet context={{ onCaseNameUpdate }} />
        )}
      </main>
    </div>
  );
};

export default MobileLayout;
